function getFloatingValue(value, precision) {
  return parseFloat(value.toFixed(precision));
}

export { getFloatingValue };
//# sourceMappingURL=get-floating-value.js.map
